import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface CertidaoPreviewDialogData {
  htmlContent: string;
}

@Component({
  selector: 'app-certidao-preview-dialog',
  templateUrl: './certidao-preview-dialog.component.html',
  styleUrls: ['./certidao-preview-dialog.component.css']
})
export class CertidaoPreviewDialogComponent {
  safeHtml: SafeHtml;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CertidaoPreviewDialogData,
    private dialogRef: MatDialogRef<CertidaoPreviewDialogComponent>,
    sanitizer: DomSanitizer
  ) {
    this.safeHtml = sanitizer.bypassSecurityTrustHtml(data.htmlContent);
  }

  confirmar(): void {
    this.dialogRef.close(true);
  }

  cancelar(): void {
    this.dialogRef.close(false);
  }
}
